const mdash = String.fromCharCode(8212); // https://www.fileformat.info/info/unicode/char/2014/index.htm
const nbsp = String.fromCharCode(160); // http://www.fileformat.info/info/unicode/char/00a0/index.htm

export {mdash, nbsp};
